// extracted by mini-css-extract-plugin
export default {"icon":"AuthProviderIcon_icon__1kpwM","twitch":"AuthProviderIcon_twitch__PmD7F","youtube":"AuthProviderIcon_youtube__njwt-"};